export function environmentBannerLabel(environment = import.meta.env.VITE_ENV) {
  return {
    sandbox: 'Sandbox Environment',
    staging: 'Staging Environment',
  }[environment];
}

export function environmentBannerClasses(
  environment = import.meta.env.VITE_ENV
) {
  return environment === 'staging'
    ? 'bg-amber-500 text-amber-950'
    : 'bg-red-600 text-white';
}
